import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TccTrackingService } from '../services/tcc-tracking.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.css']
})
export class TrackingComponent implements OnInit {
  public tccno:string;
  public status : any = {};
  public isValid : boolean;
  public isNotValid : boolean;
  constructor(private route : ActivatedRoute, private tracking : TccTrackingService) { 
   //  this.status=[];
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params:ParamMap)=>{
       let tcn = params.get('tccno');
       this.tccno = tcn;
       this.tracking.getTccStatus(this.tccno).subscribe(data => 
        {
           this.status = data;
           if(this.status.TAX_CLEARANCE_NO =="" || this.status.TAX_CLEARANCE_NO == null){
             this.isValid = false;
             this.isNotValid = true;
           }
           else{
            this.isNotValid = false;
            this.isValid = true;
           }
           console.log(this.isValid)
        }
        )
     });
  }
}